{
  "en": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here...",
        "forName": "No %{name} found",
        "hangar": "Your Hangar is empty",
        "wishlist": "Your Wishlist is empty",
        "features": "No features available",
        "fleetFeatures": "No fleet features available",
        "imports": "No imports found",
        "transfers": "No transfers yet"
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "We could not find any Records.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "There are currently no self-service features available. Check back later as new features are added regularly.",
        "fleetFeatures": "There are currently no features a fleet can switch on for itself. Check back later as new features are added regularly."
      },
      "admin": {
        "recentEdits": "No admin has changed anything yet"
      },
      "payouts": {
        "entries": "Nothing recorded yet",
        "participants": "Nobody on this tour yet",
        "transfers": "Settle the ledger to see who pays whom",
        "tours": "No tours yet"
      },
      "fleets": {
        "contracts": {
          "items": "No goods yet. Add what this contract asks for — it cannot be published empty."
        },
        "events": {
          "upcoming": "Nothing coming up",
          "past": "Nothing has happened yet",
          "archived": "Nothing archived",
          "info": {
            "upcoming": "Create an event to get the fleet together — pick a time, add slots, and let members sign up.",
            "past": "An event moves here once its end time has passed.",
            "archived": "Archiving an event takes it off the list without deleting it."
          }
        },
        "missions": {
          "active": "No missions yet",
          "archived": "Nothing archived",
          "info": {
            "active": "A mission is a reusable plan — teams, ships and slots — that you spawn events from.",
            "archived": "Archiving a mission takes it off the list without deleting it."
          }
        },
        "squadrons": {
          "headline": "No squadrons yet",
          "info": "Squadrons split the fleet into groups, each with its own members, emblem and colours. Teams sit alongside them for members who belong to more than one group."
        }
      }
    }
  }
}
